import { render, staticRenderFns } from "./SearchResultFacetsStandards.vue?vue&type=template&id=d749444a"
import script from "./SearchResultFacetsStandards.vue?vue&type=script&lang=js"
export * from "./SearchResultFacetsStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports